export const composeNonFieldErrors = (non_field_errors) => {
  let error_message = "Ha ocurrido un error"

  if (non_field_errors && non_field_errors.length > 0) {
    error_message = non_field_errors.join(". ")
  }

  return error_message
}
